export default "__VITE_ASSET__DDHPEaOM__"